import {RoomClientState} from '../RoomClientState.ts'
import {UIPopupController} from '../ui_popup/UIPopupController.ts'
import {CA} from '../analytics/Analytics.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {clientI18n} from '../ClientI18n.ts'
import {TranslationObject} from '@colonist/i18n'
import {GameSpeedSettings, RoomSettingConstants} from '@colonist/game-base-types'
import RoomGameSpeeds from '@static/images/room_game_speeds.png'
import {socket} from '../EntryShared.ts'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {GameModeDataController} from '@colonist/shared-types'

export class UIRoomCenterSettingsSpeedView {
    container: HTMLDivElement
    speedInput: HTMLHeadingElement
    speedOptions: GameSpeedSettings[]
    speedRightArrow: HTMLImageElement
    speedLeftArrow: HTMLImageElement
    speedDivBody: HTMLDivElement
    speedInfo: HTMLImageElement
    speedSettings: typeof GameSpeedSettings
    speedDefaultSetting: GameSpeedSettings
    speedSocketCommand: (value: GameSpeedSettings) => void

    constructor(container: HTMLDivElement) {
        this.container = container
        this.initGameSpeedSettings()
        this.speedOptions = []
    }

    initGameSpeedSettings() {
        this.speedInput = this.container.querySelector('#room_center_gamespeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = this.container.querySelector('#gamespeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = this.container.querySelector('#gamespeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = this.container.querySelector('#gamespeed_settings_body') as HTMLDivElement
        this.speedInfo = this.container.querySelector('#gamespeed_settings_speed_info') as HTMLImageElement
        this.speedSettings = GameSpeedSettings
        this.speedDefaultSetting = RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING
        const speedSocketCommand = (value: GameSpeedSettings) => {
            StorageWrapper.setRoomGameSpeedSetting(value)
            socket.roomClient.setGameSpeed(value)
        }
        this.speedSocketCommand = speedSocketCommand

        setElementOnClick(this.speedInfo, () => UIRoomCenterSettingsSpeedView.clickedSpeedInfo())
    }

    private static clickedSpeedInfo() {
        CA.sendGoogleAnalyticsEvent(CA.Category.Room, CA.Label.ClickedRoomGameSpeedInfo)
        const imageAlt = clientI18n.t('strings:roomPage.turnTimers')
        const gameSpeedChartImage = `<div class='room-map-preview-grid'><center><img src='${RoomGameSpeeds}' alt='${imageAlt}' style='width: 70%'></center>`
        const bodyImage: TranslationObject = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: gameSpeedChartImage,
                interpolation: {
                    escapeValue: false,
                },
            },
        }
        UIPopupController.createSimplePopup({key: 'strings:roomPage.turnTimers'}, bodyImage)
    }

    updateOptions(newRoomState: RoomClientState) {
        const gameModeData = GameModeDataController.getModeDataForMode(newRoomState.gameSetting.modeSetting)
        this.speedOptions = gameModeData?.allowedGameTimers ?? []
    }
}
